"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKpiDrill = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var general_1 = require("../../../events/general");
var legacyDashboardsSelectors_1 = require("../../../store/legacyDashboards/legacyDashboardsSelectors");
var kpiDrillValidationUtils_1 = require("./kpiDrillValidationUtils");
function validateKpiDrill(drill, ctx, cmd) {
    var legacyDashboards, messageDetail;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(legacyDashboardsSelectors_1.selectLegacyDashboards)];
            case 1:
                legacyDashboards = _a.sent();
                try {
                    kpiDrillValidationUtils_1.validateKpiDrillTarget(drill, legacyDashboards);
                }
                catch (ex) {
                    messageDetail = ex.message;
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Invalid KPI drill target. Error: " + messageDetail);
                }
                return [2 /*return*/];
        }
    });
}
exports.validateKpiDrill = validateKpiDrill;
//# sourceMappingURL=kpiDrillValidation.js.map